// src/features/landing/presentation/components/PremiumHeroSection.jsx
// eslint-disable-next-line no-unused-vars
import React, { useState, useRef, useEffect } from "react";

// eslint-disable-next-line no-unused-vars
const JOB_TYPE_MAP = {
    "총무": "총무",
    "설계사": "설계사",
    "TM설계사": "TM설계사",
    "영업지원": "영업지원",
    "영업교육": "영업교육",
};

// 커스텀 드롭다운 컴포넌트 입니다.
// eslint-disable-next-line no-unused-vars
function CustomSelect({ value, onChange, options, placeholder, icon }) {
    const [isOpen, setIsOpen] = useState(false);
    const dropdownRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    const handleSelect = (option) => {
        onChange(option);
        setIsOpen(false);
    };

    return (
        <div className="custom-select" ref={dropdownRef}>
            <div className="select-trigger" onClick={() => setIsOpen(!isOpen)}>
                <span className="select-icon">{icon}</span>
                <span className={`select-value ${!value ? 'placeholder' : ''}`}>
                    {value || placeholder}
                </span>
                <span className={`select-arrow ${isOpen ? 'open' : ''}`}>▼</span>
            </div>
            {isOpen && (
                <div className="select-dropdown">
                    <div
                        className={`select-option ${!value ? 'selected' : ''}`}
                        onClick={() => handleSelect("")}
                    >
                        {placeholder}
                    </div>
                    {options.map((option) => (
                        <div
                            key={option}
                            className={`select-option ${value === option ? 'selected' : ''}`}
                            onClick={() => handleSelect(option)}
                        >
                            {option}
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
}

export function PremiumHeroSection({ onSearch }) { // eslint-disable-line no-unused-vars
    // eslint-disable-next-line no-unused-vars
    const [region, setRegion] = useState("");
    // eslint-disable-next-line no-unused-vars
    const [position, setPosition] = useState("");

    // eslint-disable-next-line no-unused-vars
    const regions = [
        "서울특별시", "경기도", "인천광역시", "부산광역시", "대구광역시", "광주광역시", "대전광역시", "울산광역시", "세종특별자치시", "강원도", "충북남도", "충청남도", "전라북도", "전라남도", "경상북도", "경상남도", "제주특별자치시"
    ];

    // eslint-disable-next-line no-unused-vars
    const positions = [
        "총무",
        "설계사",
        "TM설계사",
        "영업지원",
        "영업교육",
    ];

    // eslint-disable-next-line no-unused-vars
    const handleSearch = () => {
        const filters = {
            companySido: region || undefined,
            jobType: position ? JOB_TYPE_MAP[position] : undefined,
        };
        onSearch?.(filters);
    };

    return (
        <section className="premium-hero-section">
            <div className="hero-content">
                <div className="hero-text">
                    <h1 className="hero-title">
                        GA 전문 인력 채용사이트{" "}
                        <br />
                        <span className="brand-nowrap"><span className="brand-name">라이징브로커즈</span>에서</span>
                        <br />
                        채용의 날개를 달아드립니다.
                    </h1>

                    {/* 검색 기능 - 추후 활성화 예정
                    <div className="search-box">
                        <CustomSelect
                            value={region}
                            onChange={setRegion}
                            options={regions}
                            placeholder="지역선택"
                            icon="📍"
                        />
                        <CustomSelect
                            value={position}
                            onChange={setPosition}
                            options={positions}
                            placeholder="직종선택"
                            icon="👤"
                        />
                        <button className="search-button" onClick={handleSearch}>
                            검색
                        </button>
                    </div>
                    */}
                </div>

                <div className="hero-illustration">
                    <div className="illustration-container">
                        <div className="business-person person-1">
                            <div className="person-head"></div>
                            <div className="person-body"></div>
                            <div className="briefcase"></div>
                        </div>
                        <div className="business-person person-2">
                            <div className="person-head"></div>
                            <div className="person-body"></div>
                            <div className="document"></div>
                        </div>
                        <div className="floating-paper paper-1"></div>
                        <div className="floating-paper paper-2"></div>
                        <div className="floating-paper paper-3"></div>
                    </div>
                </div>
            </div>

            <style jsx>{`
                .premium-hero-section {
                    width: 100%;
                    background: linear-gradient(135deg, #fd7314 0%, #f1863f 100%);
                    padding: 10px 40px 0px;
                    position: relative;
                    overflow: visible;
                    z-index: 10;
                }

                .premium-hero-section::before {
                    content: "";
                    position: absolute;
                    top: 0;
                    left: 0;
                    right: 0;
                    bottom: 0;
                    background: radial-gradient(
                        circle at 20% 50%,
                        rgba(255, 255, 255, 0.1) 0%,
                        transparent 50%
                    );
                    pointer-events: none;
                }

                .hero-content {
                    max-width: 1400px;
                    margin: 0 auto;
                    display: flex;
                    //align-items: flex-start;
                    justify-content: space-between;
                    gap: 60px;
                    position: relative;
                    z-index: 1;
                }

                .hero-text {
                    flex: 1;
                    max-width: 700px;
                }

                .hero-title {
                    font-size: 2.8rem;
                    font-weight: 700;
                    color: white;
                    margin: 0;
                    line-height: 1.5;
                }

                .brand-nowrap {
                    display: inline-block;
                    white-space: nowrap;
                }

                .brand-name {
                    color: #f1f034;
                    text-decoration: underline;
                    text-decoration-thickness: 3px;
                    text-underline-offset: 5px;
                }

                .search-box {
                    display: flex;
                    gap: 15px;
                    align-items: center;
                    justify-content: center;
                    position: relative;
                    z-index: 100;
                }

                .search-filter {
                    flex: 1;
                    background: white;
                    border-radius: 8px;
                    padding: 16px 20px;
                    display: flex;
                    align-items: center;
                    gap: 12px;
                    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
                }

                .filter-icon {
                    font-size: 1.5rem;
                }

                .filter-select {
                    flex: 1;
                    border: none;
                    outline: none;
                    font-size: 1rem;
                    font-weight: 500;
                    color: #333;
                    background: transparent;
                    cursor: pointer;
                }

                .filter-select option {
                    padding: 10px;
                }

                .search-button {
                    background: #1a1a1a;
                    color: white;
                    border: none;
                    border-radius: 8px;
                    padding: 18px 50px;
                    font-size: 1.1rem;
                    font-weight: 700;
                    cursor: pointer;
                    transition: all 0.3s ease;
                    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
                }

                .search-button:hover {
                    background: #333;
                    transform: translateY(-2px);
                    box-shadow: 0 6px 16px rgba(0, 0, 0, 0.4);
                }

                /* Custom Select Styles */
                .custom-select {
                    position: relative;
                    flex: none;
                    min-width: 180px;
                    width: 220px;
                }

                .select-trigger {
                    background: white;
                    border-radius: 8px;
                    padding: 16px 20px;
                    display: flex;
                    align-items: center;
                    gap: 12px;
                    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
                    cursor: pointer;
                    transition: all 0.2s ease;
                }

                .select-trigger:hover {
                    box-shadow: 0 6px 16px rgba(0, 0, 0, 0.15);
                }

                .select-icon {
                    font-size: 1.3rem;
                }

                .select-value {
                    flex: 1;
                    font-size: 1rem;
                    font-weight: 500;
                    color: #333;
                }

                .select-value.placeholder {
                    color: #999;
                }

                .select-arrow {
                    font-size: 0.7rem;
                    color: #666;
                    transition: transform 0.2s ease;
                }

                .select-arrow.open {
                    transform: rotate(180deg);
                }

                .select-dropdown {
                    position: absolute;
                    top: calc(100% + 8px);
                    left: 0;
                    right: 0;
                    background: white;
                    border-radius: 12px;
                    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.15);
                    z-index: 9999;
                    max-height: 280px;
                    overflow-y: auto;
                    animation: dropdownFadeIn 0.2s ease;
                }

                @keyframes dropdownFadeIn {
                    from {
                        opacity: 0;
                        transform: translateY(-8px);
                    }
                    to {
                        opacity: 1;
                        transform: translateY(0);
                    }
                }

                .select-dropdown::-webkit-scrollbar {
                    width: 6px;
                }

                .select-dropdown::-webkit-scrollbar-track {
                    background: #f1f1f1;
                    border-radius: 3px;
                }

                .select-dropdown::-webkit-scrollbar-thumb {
                    background: #ccc;
                    border-radius: 3px;
                }

                .select-dropdown::-webkit-scrollbar-thumb:hover {
                    background: #aaa;
                }

                .select-option {
                    padding: 14px 20px;
                    font-size: 0.95rem;
                    color: #333;
                    cursor: pointer;
                    transition: all 0.15s ease;
                    border-bottom: 1px solid #f0f0f0;
                }

                .select-option:last-child {
                    border-bottom: none;
                }

                .select-option:hover {
                    background: #f8f9fa;
                    color: #f16102;
                }

                .select-option.selected {
                    background: #e8f0ff;
                    color: #f16102;
                    font-weight: 600;
                }

                .hero-illustration {
                    flex: 1;
                    max-width: 500px;
                    position: relative;
                    margin-top: 30px;
                }

                .illustration-container {
                    position: relative;
                    width: 100%;
                    height: 60px;
                }

                .business-person {
                    position: absolute;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                }

                .person-1 {
                    left: 20%;
                    top: 20%;
                    animation: float 3s ease-in-out infinite;
                }

                .person-2 {
                    right: 15%;
                    top: 10%;
                    animation: float 3s ease-in-out infinite 1s;
                }

                .person-head {
                    width: 60px;
                    height: 60px;
                    background: #ffd700;
                    border-radius: 50%;
                    margin-bottom: 10px;
                    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
                }

                .person-body {
                    width: 80px;
                    height: 100px;
                    background: #2c3e50;
                    border-radius: 10px;
                    position: relative;
                    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
                }

                .briefcase {
                    width: 50px;
                    height: 40px;
                    background: #8b4513;
                    border-radius: 5px;
                    position: absolute;
                    top: 140px;
                    left: -70px;
                    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
                }

                .document {
                    width: 50px;
                    height: 60px;
                    background: white;
                    border-radius: 5px;
                    position: absolute;
                    top: 130px;
                    right: -60px;
                    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
                }

                .floating-paper {
                    position: absolute;
                    width: 60px;
                    height: 80px;
                    background: rgba(255, 255, 255, 0.9);
                    border-radius: 8px;
                    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
                    animation: floatPaper 4s ease-in-out infinite;
                }

                .paper-1 {
                    top: 10%;
                    left: 10%;
                    animation-delay: 0s;
                }

                .paper-2 {
                    top: 60%;
                    right: 25%;
                    animation-delay: 1.5s;
                }

                .paper-3 {
                    bottom: 15%;
                    left: 35%;
                    animation-delay: 3s;
                }

                @keyframes float {
                    0%,
                    100% {
                        transform: translateY(0);
                    }
                    50% {
                        transform: translateY(-20px);
                    }
                }

                @keyframes floatPaper {
                    0%,
                    100% {
                        transform: translateY(0) rotate(0deg);
                    }
                    50% {
                        transform: translateY(-30px) rotate(5deg);
                    }
                }

                @media (max-width: 1024px) {
                    .hero-content {
                        flex-direction: column;
                        gap: 40px;
                    }

                    .hero-text {
                        max-width: 100%;
                        text-align: center;
                    }

                    .hero-title {
                        font-size: 1.8rem;
                    }

                    .hero-illustration {
                        max-width: 400px;
                    }
                }

                @media (max-width: 768px) {
                    .premium-hero-section {
                        padding: 0px 20px 40px;
                    }

                    .hero-title {
                        font-size: 1.5rem;
                    }

                    .search-box {
                        flex-direction: column;
                        width: 100%;
                    }

                    .custom-select {
                        width: 100%;
                        min-width: unset;
                    }

                    .select-trigger {
                        padding: 14px 16px;
                    }

                    .select-dropdown {
                        max-height: 240px;
                    }

                    .select-option {
                        padding: 12px 16px;
                    }

                    .search-filter {
                        width: 100%;
                    }

                    .search-button {
                        width: 100%;
                        padding: 16px 40px;
                    }

                    .hero-illustration {
                        display: none;
                    }
                }
            `}</style>
        </section>
    );
}
